import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Figure } from '@studiometa/ui';
import { isDev } from './config.js';
import HeroSlider from './components/HeroSlider.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *     HeroSlider: Array<Promise<import('./components/HeroSlider.js').default>>
 *     Lightbox: Array<Promise<import('./components/Lightbox.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Figure,
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      HeroSlider,
      Lightbox: () => importWhenVisible(() => import('./components/Lightbox.js'), 'Lightbox'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
